import { FC } from 'react'
import { Form as FinalForm } from 'react-final-form'

import { Grid, Typography, IconButton, makeStyles, Button } from '@material-ui/core'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import Radio from '../../../control/radio/radio'
import useTranslate from '../../../i18n/useTranslate'
import MyTextfield from '../../../control/textfield/textfield'
import { LoginFormT } from '../../../services/authen/useLogin'

interface FormProps {
    onSubmit: (values: LoginFormT) => void
    onClickDisplayControl: () => void
    onClickForgotPW: () => void
    onClickRegister: () => void
    displayPW: boolean
}
const Form: FC<FormProps> = ({ onSubmit, onClickDisplayControl, onClickForgotPW, onClickRegister, displayPW }) => {
    const translate = useTranslate()
    const classes = useStyles()

    return (
        <Grid container>
            <Grid item xs={12} className={classes.title}>
                <Typography variant="h6" className={classes.typo}>
                    {translate.get('UM.LOGIN.TITLE')}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <FinalForm onSubmit={onSubmit}>
                    {({ handleSubmit, form }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} style={{ padding: '8px 8px 0px' }}>
                                        <Typography className={classes.typo}>
                                            {translate.get('UM.LOGIN.USER-STATUS')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{ padding: '0px 8px' }}>
                                        <Radio
                                            name="type"
                                            options={[
                                                { id: '1', name: translate.get('UM.LOGIN.RESEARCHER') },
                                                { id: '2', name: translate.get('UM.LOGIN.OFFICER') },
                                            ]}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ padding: '0px 8px' }}>
                                        <MyTextfield
                                            name="username"
                                            materialInputProps={{
                                                label: translate.get('UM.LOGIN.USERNAME'),
                                                disabled: false,
                                                placeholder: translate.get('UM.LOGIN.USERNAME'),
                                                size: 'medium',
                                            }}
                                            handleValueChange={(val: string) => {
                                                if (val) {
                                                    const txtLogin = val.replace(/[ก-๙]|\s/g, '')
                                                    form.change('username', txtLogin)
                                                }
                                            }}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ padding: '0px 8px' }}>
                                        <MyTextfield
                                            name="password"
                                            type={displayPW ? 'text' : 'password'}
                                            materialInputProps={{
                                                label: translate.get('UM.LOGIN.PASSWORD'),
                                                disabled: false,
                                                placeholder: translate.get('UM.LOGIN.PASSWORD'),
                                                size: 'medium',
                                            }}
                                            icon={
                                                <IconButton size="small" onClick={onClickDisplayControl}>
                                                    {displayPW ? (
                                                        <Visibility style={{ fontSize: '1.2rem' }} />
                                                    ) : (
                                                        <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                                    )}
                                                </IconButton>
                                            }
                                            handleValueChange={(val: string) => {
                                                if (val) {
                                                    const txtLogin = val.replace(/[ก-๙]|\s/g, '')
                                                    form.change('password', txtLogin)
                                                }
                                            }}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} style={{ padding: '0px 8px 8px' }}>
                                        <Grid container justify="flex-end">
                                            <Typography className={classes.link} onClick={onClickForgotPW}>
                                                {translate.get('UM.LOGIN.FORGOT-PASSWORD')}
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                        >
                                            {translate.get('UM.LOGIN.LOGIN')}
                                        </Button>
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                        <Grid container justify="center">
                                            <Typography style={{ color: 'red' }}>
                                                {translate.get('UM.LOGIN.DES_REGISTER')}
                                            </Typography>
                                            <Typography className={classes.link} onClick={onClickRegister}>
                                                {translate.get('UM.LOGIN.REGISTER')}
                                            </Typography>
                                            <Typography className={classes.link} onClick={onClickForgotPW}>
                                                {translate.get('UM.LOGIN.FORGOT-PASSWORD')}
                                            </Typography> 
                                        </Grid>
                                    </Grid>*/}
                                </Grid>
                            </form>
                        )
                    }}
                </FinalForm>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    title: {
        margin: '16px 0px',
    },
    typo: {
        fontWeight: 'bold',
    },
    link: {
        color: '#0022FF',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
}))

export default Form
